import { TagVariant as n } from "../../../../internal/Tag/types.js";
const u = (e) => e === "Active", c = (e) => e === "Repaid", r = (e) => e === "Active" ? "capital.remaining" : "capital.requestedFunds", d = (e) => e.status === "Active" ? e.remainingTotalAmount : e.grantAmount, o = ({ status: e, missingActions: t }) => {
  switch (e) {
    case "Active":
      return;
    case "Failed":
      return "capital.failed";
    case "Pending":
      return t && t.length ? "capital.actionNeeded" : "capital.pending";
    case "Repaid":
      return "capital.fullyRepaid";
    case "Revoked":
      return "capital.revoked";
    case "WrittenOff":
      return "capital.writtenOff";
  }
}, l = ({ status: e, missingActions: t }) => {
  switch (e) {
    case "Failed":
      return n.ERROR;
    case "Pending":
      return t != null && t.length ? n.WARNING : n.DEFAULT;
    case "Repaid":
      return n.LIGHT;
    case "Revoked":
    case "WrittenOff":
      return n.WARNING;
    default:
      return n.DEFAULT;
  }
}, p = (e) => {
  const t = /* @__PURE__ */ new Date(), a = /* @__PURE__ */ new Date();
  return a.setDate(t.getDate() + e), a;
}, y = (e) => {
  var a, s;
  const t = ((a = e.missingActions) == null ? void 0 : a.some((i) => i.type === "signToS")) || !1;
  switch (e.status) {
    case "Pending":
      return (s = e.missingActions) != null && s.length ? t ? "capital.signTheTermsToReceiveYourFunds" : void 0 : "capital.youShouldGetTheFundsWithinOneBusinessDay";
    case "Failed":
      return "capital.weCouldNotProcessThisRequestTryAgain";
    case "WrittenOff":
      return "capital.youAcceptedTheseFundsButDidNotRepayThem";
    case "Revoked":
      return "capital.youAcceptedButThenReturnedTheseFunds";
    default:
      return;
  }
}, T = (e) => {
  var s;
  const t = e.status === "Active", a = e.status === "Pending";
  return {
    amount: d(e),
    amountLabelKey: r(e.status),
    hasAlerts: a,
    hasDetails: u(e.status),
    hasUnscheduledRepaymentDetails: t && !!((s = e.unscheduledRepaymentAccounts) != null && s.length),
    // The grant revocation account details is currently not ready to be rendered.
    // A future iteration of this component might include revocation account details.
    // Only then should the following line be uncommented.
    //
    // hasRevocationDetails: isGrantActive && grant.revocationAccount !== undefined,
    isAmountColorSecondary: !t,
    isBackgroundFilled: c(e.status),
    isGrantIdVisible: !t,
    isLabelColorSecondary: t,
    isProgressBarVisible: t,
    repaymentPeriodEndDate: p(e.repaymentPeriodLeft),
    statusKey: o(e),
    statusTagVariant: l(e),
    statusTooltipKey: y(e)
  };
};
export {
  T as getGrantConfig,
  y as getStatusTooltipKey
};
